export const stringIsEmpty = (value) => {
    return value ? value.toString().trim().length === 0 : true;
};

export const DATE_FORMAT = 'MM/DD/YYYY';
export const DATE_YEAR_FORMAT = 'YYYY';
export const DATE_TIME_FORMAT = 'MM/DD/YYYY h:mm A';
export const TIME_FORMAT = 'h:mm A';


// WEBPACK FOOTER //
// ./src/common/StringTools.js